exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toggleInput___ncKr- {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.toggleLabel___1oI1G {\n  margin-right: 8px;\n  margin-bottom: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #21201f;\n  text-transform: none;\n  letter-spacing: normal;\n}\n.toggleSection___jaM7h {\n  border-top: 1px solid #d9d9d9;\n  border-bottom: 1px solid #d9d9d9;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n}\n.toggleSection___jaM7h .passcode-account-settings {\n  display: none;\n}\n.toggleSection___jaM7h .passcode-input {\n  margin-top: 0!important;\n  justify-content: flex-start !important;\n}\n.toggleSection___jaM7h .passcode-toggle {\n  margin-bottom: 0!important;\n  padding-top: 0!important;\n}\n.toggleSection___jaM7h .passcode-heading > span {\n  margin-right: 8px;\n  font-weight: 600 !important;\n}\n", ""]);

// exports
exports.locals = {
	"toggleInput": "toggleInput___ncKr-",
	"toggleLabel": "toggleLabel___1oI1G",
	"toggleSection": "toggleSection___jaM7h"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/common/FormFields/formFields.module.less
// module id = 2302
// module chunks = 71